import React, { PureComponent } from 'react'

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../containers/dockPadStyle'
import classNames from 'classnames'
import { compose } from 'redux'

import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import PropTypes from "prop-types";
import {
    dockPadEntityMapToList,
} from '../containers/DockPadFormTemplates'
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { getNewId } from '../actions/home.actions'
import { getFirebase } from 'react-redux-firebase'

class ResourceList extends PureComponent {
  async onNewTaskResourceClick() {
    const { taskResources, onChange } = this.props;
    const newId = getNewId(getFirebase(), "projectId", "tasksUpload");

    const newTasks = {
      [newId]: {
        resourceId: null,
        quantity: 0
      },
      ...taskResources
    };

    onChange(newTasks);
  }

  async selectChange(itemUID, event) {
    const { taskResources, onChange } = this.props;

    const projectResourceId = event.target.value;
    const oldTask = taskResources[itemUID];
    oldTask["resourceId"] = projectResourceId;
    delete oldTask.uid

    const newTasks = {
      [itemUID]: oldTask,
      ...taskResources
    };

    onChange(newTasks);
  }

  async quantityChange(itemUID, event) {
    const { taskResources, onChange } = this.props;

    const quantity = event.target.value;
    const oldTask = taskResources[itemUID];
    oldTask["quantity"] = quantity;
    delete oldTask.uid;

    const newTasks = {
      [itemUID]: oldTask,
      ...taskResources
    };

    onChange(newTasks);
  }

  onDelete(itemUID) {
    const { taskResources, onChange } = this.props;

    delete taskResources[itemUID]

    onChange(taskResources);
  }

  render() {
    const { classes, taskResources, projectResource } = this.props;
    const taskResourceList = dockPadEntityMapToList(taskResources);
    const projectResourceList = dockPadEntityMapToList(projectResource);

    return (
      <div className={classNames(classes.verticalFlex)}>
        <div className={classNames(classes.standardSeperated)}>
          <Button onClick={this.onNewTaskResourceClick.bind(this)}>
            <AddCircleIcon
              className={classNames(classes.standardRightMargin)}
            />
            Add Resource
          </Button>
        </div>
        <div>
          <List component="nav">
            {taskResourceList.map(item => {
              const resourceId = !!item.resourceId ? item.resourceId : "";
              const quantity = !!item.quantity ? item.quantity : "";
              return (
                <ListItem key={item.uid}>
                  <div className={classNames(classes.standardSeperated)}>
                    <TextField
                      select
                      value={resourceId}
                      onChange={this.selectChange.bind(this, item.uid)}
                      label="Resource"
                    >
                      {projectResourceList.map(option => (
                        <MenuItem key={option.uid} value={option.uid}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      type="number"
                      value={quantity}
                      onChange={this.quantityChange.bind(this, item.uid)}
                      className={classNames(classes.standardLeftMargin)}
                      label="Quantity"
                    />
                    <IconButton onClick={this.onDelete.bind(this, item.uid)} >
                        <CloseIcon />
                    </IconButton>
                  </div>
                </ListItem>
              );
            })}
          </List>
        </div>
      </div>
    );
  }
}

ResourceList.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired
};

ResourceList.defaultProps = {
    onChange: () => { },
    value: {}
}

export default compose(withStyles(styles, { withTheme: true }))(ResourceList)



// WEBPACK FOOTER //
// ./src/components/ResourceList.tsx